import Picker from "../picker/picker";
import {Segment} from "../segment/segment";

async function submit(query, endpoint, applySegment) {
    const queryJson = {
        "start": Picker.start_YYYYMMDDHHmmss(),
        "end": Picker.end_YYYYMMDDHHmmss(),
        "timezone": Picker.timezone(),
        "unit": Picker.unit(),
        "timeseriesGranularity": Picker.timeseries_granularity(),
        "query": query
    };

    // apply segment unless applySegment is defined and is true
    if (applySegment === undefined || applySegment) {
        let segment = Segment.getSegmentQuery();
        if (segment !== "")
            queryJson["segment"] = segment;
    }


    const response = await fetch(endpoint, {
        method: "POST",
        redirect: "error",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(queryJson)
    });

    if (!response.ok)
        throw new Error("Request failed")

    let json = await response.json();

    // replace any NaNs with 0
    for (let r=0;r<json.rows.length;++r) {
        for (let c=0;c<json.rows[r].length;++c) {
            if (json.rows[r][c] === "NaN")
                json.rows[r][c] = 0;
        }
    }

    return json;
}

const Submit = {
    "submit": submit
};

export default Submit;